import { ApiUtility } from "../../Utilities/ApiUtility.axios";
export const enum LogTypes {
  All,
  Vouchers,
  Master,
  Users,
  Settings,
  Security,
  Reports,
  Email,
}

class LogService {
  route = `V1/API/Billing/Acc_User_Log`;

  getUserLog = (
    companyId: string,
    userId: string,
    types: LogTypes | undefined,
    fromDate: string,
    toDate: string,
    search: any,
    start: number,
    length: number
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}`, {
      userId,
      types,
      fromDate,
      toDate,
      search,
      start,
      length,
    });
}
export default new LogService();
